import { useAppContext } from 'context';
import Text from '../text';
import {
  FooterWatermark,
  FooterLogo,
} from 'features/store-front/components/store-footer/styles/footer.style';
import { capitalize } from 'utils/format-value';
import Whatadeal from 'assets/images/whatadeal.png';
import { Color } from 'assets/theme/colors';

const BrandFooter = () => {
  const currentYear = new Date().getFullYear();
  const {
    state: { vendorBusiness, vendorStoreDetails },
  } = useAppContext();

  const customTheme = vendorStoreDetails?.storeSettings ?? null;
  const textColor = customTheme ? customTheme?.fontColor : Color.white;

  return (
    <FooterWatermark color={textColor}>
      <p>{`© ${currentYear} ${capitalize(vendorBusiness?.businessName)} `}</p>
      <div className="brand-logo">
        {/* <Text color={textColor}>Powered by</Text> */}
        <FooterLogo>
          <img src={Whatadeal} alt="whatadeal logo" className="logo" />
        </FooterLogo>
      </div>
    </FooterWatermark>
  );
};

export default BrandFooter;
